module.exports = __webpack_public_path__ + "img/S-WEB-Goal-11.7686c019.png";